export default __webpack_public_path__ + "static/media/roadmap-line.6ecb6c39.png";